document.addEventListener('DOMContentLoaded', function() {
  const slides = document.querySelectorAll('.slideshow__slide');

  slides.forEach(slide => {
    const link = slide.querySelector('a.slideshow__media');
    if (!link) return;

    slide.addEventListener('click', function(e) {
      // Only trigger if user isn't dragging
      if (!slide.classList.contains('is-dragging')) {
        window.location = link.href;
      }
    });
  });
});
